import React from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Column, DataTable } from '../../components/ShootingData/DataTable';
import { useSessions } from '../../hooks/useSessions';
import { EnhancedSession } from '../../types/ui/userSession';


const sessionColumns: Column<EnhancedSession>[] = [
  { header: 'Date', accessor: s => s.dateLabel, align: 'left' },
  { header: 'Time', accessor: s => s.timeLabel, align: 'center' },
  { header: 'Duration', accessor: s => s.durationLabel, align: 'center' },
  { header: 'Scenarios', accessor: s => s.scenarios.toString(), align: 'center' },
];

const History: React.FC = () => {
  const navigate = useNavigate();
  const {
    data: sessions = [],
    isLoading,
    error,
  } = useSessions();

  if (error) {
    return (
      <Box sx={{ p: 4, backgroundColor: '#0D1117', minHeight: '100vh' }}>
        <Alert severity="error">{error.message}</Alert>
      </Box>
    );
  }

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 4, backgroundColor: 'rgba(14,23,32,0)', minHeight: '100vh' }}>
      <DataTable<EnhancedSession>
        title="Sessions"
        data={sessions}
        isLoading={isLoading}
        error={undefined}
        columns={sessionColumns}
        onRowClick={s =>
          navigate(`${s.id}`, { state: s })
        }


      />

        
    </Box>
  );
};

export default History;
